import {AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormsService} from '../../services/forms.service';
import {KfRegistrationService} from '../../../kf-data-entry/services/kf-registration.service';
import {AuthService} from '../../../core/services/auth.service';
import {User} from '../../../kf-data-entry/models/user.interface';
import {RoundOfQuestionsService} from '../../../intelligence-reporting/services/round-of-questions.service';
import {QuestionsService} from '../../../intelligence-reporting/services/questions.service';
import {Questions} from '../../../intelligence-reporting/models/questions.interface';
import {Master} from '../../../admin/models/master.interface';
import {Forms} from '../../models/forms.interface';
import {FormArray, FormBuilder, Validators} from '@angular/forms';
import {Answer} from '../../models/answer.interface';
import {MatTabGroup} from '@angular/material/tabs';
import {MessageService} from '../../../shared/services/message.service';

@Component({
  selector: 'app-edit-forms',
  templateUrl: './edit-forms.component.html',
  styleUrls: ['./edit-forms.component.scss']
})
export class EditFormsComponent implements OnInit, AfterContentChecked {

  country!: boolean;
  countryOrSystemName = '';
  countryOrSystemId!: number;
  groupIndex: number | null = 0;
  unansweredMap: Map<string, number> = new Map<string, number>();
  user!: User;
  categories!: Master[];
  categoriesSelected: boolean[] = [];
  availableAnswers = [[]];
  categoriesWithQuestions: Master[] = [];
  form!: Forms;
  questions!: Questions[];
  lastYearAnswers!: Answer[];
  formAnswers!: Answer[];
  markAsCompletedAvailable = false;
  yearPreview!: number;
  sharingLevel = [
    {value: 'UNDISCLOSED', description: 'Undisclosed'},
    {value: 'MEMBERS', description: 'Members'},
    {value: 'PUBLIC', description: 'Public'},
  ];
  reasonUnanswered = [
    {value: 'NO_INFO_AVAILABLE', description: 'No info available'},
    {value: 'LEGAL_GROUNDS', description: 'Legal Grounds'},
    {value: 'COMMERCIAL_SENSITIVITY', description: 'Commercial Sensitivity'},
  ];

  answerForm = this.formBuilder.group({
    answers: this.formBuilder.array([])
  });

  @ViewChild(MatTabGroup)
  group!: MatTabGroup;

  get answerControl(): FormArray {
    return this.answerForm.get('answers') as FormArray;
  }

  constructor(private readonly formsService: FormsService,
              private readonly kfRegistrationService: KfRegistrationService,
              private readonly questionsService: QuestionsService,
              private readonly roundOfQuestionsService: RoundOfQuestionsService,
              private formBuilder: FormBuilder,
              readonly router: Router,
              private readonly route: ActivatedRoute,
              private authService: AuthService,
              private messageService: MessageService,
              private cd: ChangeDetectorRef) {
    this.country = this.router.url.includes('country');
  }

  ngOnInit(): void {
    this.kfRegistrationService.getUser(this.authService.getEmail()).subscribe(
      user => {
        this.user = user;
        this.questionsService.getAllQuestionCategories('', {page: 0, size: 100, sort: 'id', direction: 'asc'}).subscribe(
          data => {
            this.categories = data.content;
            data.content.forEach(() => this.categoriesSelected.push(false));
            this.route.params.subscribe(
              urlParams => {
                this.countryOrSystemName = this.country ? this.user?.weeeSystem?.country.name : this.user?.weeeSystem?.description;
                this.countryOrSystemId = urlParams.userId;
                if (!this.router.url.includes('preview')) {
                  this.formsService.getFormQuestions(
                    urlParams.roundOfQuestionsId || urlParams.id,
                    this.country ? 'Country' : 'System',
                    this.country ? this.user?.weeeSystem?.country.id : undefined,
                    !this.country ? this.user?.weeeSystem?.id : undefined).subscribe(
                    formQuestions => {
                      this.questions = formQuestions.questions;
                      this.lastYearAnswers = formQuestions.lastYearAnswers;
                      formQuestions.questions.forEach(question => {
                        const categoryIndex = this.categories.findIndex(cat => cat.id === question.category.id);
                        if (!this.categoriesSelected[categoryIndex]) {
                          this.categoriesWithQuestions.push(this.categories[categoryIndex]);
                          this.categoriesSelected[categoryIndex] = true;
                          let countCategoryQuestions = 0;
                          formQuestions.questions.forEach(
                            q => q.category.id === this.categories[categoryIndex].id ? countCategoryQuestions += 1 : null
                          );
                          this.unansweredMap.set(this.categories[categoryIndex].description, countCategoryQuestions);
                        }
                      });
                      this.formsService.getForm(urlParams.roundOfQuestionsId || urlParams.id, this.country, urlParams.userId).subscribe(
                        form => {
                          this.form = form;
                          this.setArrayForm();
                        }
                      );
                    }
                  );
                } else {
                  this.formsService.getFormQuestions(urlParams.roundOfQuestionsId || urlParams.id, '').subscribe(
                    data3 => {
                      this.questions = data3.questions;
                      this.lastYearAnswers = data3.lastYearAnswers;
                      data3.questions.forEach(question => {
                        const categoryIndex = this.categories.findIndex(cat => cat.id === question.category.id);
                        if (!this.categoriesSelected[categoryIndex]) {
                          this.categoriesWithQuestions.push(this.categories[categoryIndex]);
                          this.categoriesSelected[categoryIndex] = true;
                          let countCategoryQuestions = 0;
                          data3.questions.forEach(
                            q => q.category.id === this.categories[categoryIndex].id ? countCategoryQuestions += 1 : null
                          );
                          this.unansweredMap.set(this.categories[categoryIndex].description, countCategoryQuestions);
                        }
                        this.route.params.subscribe(
                          data4 => {
                            this.yearPreview = data4.year;
                          }
                        );
                        this.setArrayForm();
                      });
                    }
                  );
                }
              }
            );
          }
        );
      }
    );
  }

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }

  setLastYearAnswer(questionIndex: number): void {
    if (this.answerControl.at(questionIndex).value.question.multiSelect) {
      this.answerControl.at(questionIndex).get('answer')?.setValue(this.lastYearAnswers[questionIndex].answerString.split(';'));
    }
    else {
      this.answerControl.at(questionIndex).get('answer')?.setValue(this.lastYearAnswers[questionIndex].answerString);
    }
    this.answerControl.at(questionIndex).get('sharingLevel')?.setValue(this.lastYearAnswers[questionIndex].sharingLevel);
    this.answerControl.at(questionIndex).get('reasonUnanswered')?.setValue(this.lastYearAnswers[questionIndex].reasonUnanswered);
  }

  removeRequired(index: number, changeSelector: boolean): void {
    const answerFormat = JSON.parse(this.questions[index].answerFormatString);
    if (this.answerControl.at(index).get('reasonUnanswered')?.value != null) {
      if (changeSelector) {
        this.answerControl.at(index).get('answer')?.setValue(null);
      }
      this.answerControl.at(index).get('answer')?.clearValidators();
      switch (this.questions[index].answerType) {
        case 'NUMBER':
          this.answerControl.at(index).get('answer')?.setValidators([Validators.min(answerFormat.Min), Validators.max(answerFormat.Max)]);
          break;
        case 'TEXT':
          this.answerControl.at(index).get('answer')?.setValidators([Validators.maxLength(answerFormat.MaxLength)]);
          break;
        default:
          break;
      }
    } else {
      switch (this.questions[index].answerType) {
        case 'NUMBER':
          this.answerControl.at(index).get('answer')?.setValidators(
            [Validators.min(answerFormat.Min), Validators.max(answerFormat.Max), Validators.required]);
          break;
        case 'TEXT':
          this.answerControl.at(index).get('answer')?.setValidators([Validators.maxLength(answerFormat.MaxLength), Validators.required]);
          break;
        default:
          this.answerControl.at(index).get('answer')?.setValidators([Validators.required]);
          break;
      }
    }
    this.answerControl.at(index).get('answer')?.updateValueAndValidity();
  }

  cancel(): void {
    this.redirectUrl();
  }

  saveAnswer(completed: boolean = false): void {
    if (Object.keys(this.formAnswers).length === 0 && this.form.status === 'Not Started') {
      this.formsService.saveAnswerForm(
        this.form.id,
        this.country ? this.countryOrSystemId : undefined,
        !this.country ? this.countryOrSystemId : undefined).subscribe();
    }

    const listAnswers: Answer[] = [];
    this.answerControl.controls.forEach(answer => {
      let answerString = answer.get('answer')?.value?.toString();
      if (answer.get('question')?.value.multiSelect) {
        const answerFormat = JSON.parse(answer.get('question')?.value.answerFormatString);
        const selectedAnswers = answer.get('answer')?.value?.toString();
        answerString = undefined;
        answerFormat.AvailableAnswers.forEach((a: string) => {
          if (selectedAnswers?.includes(a)) {
            if (answerString === undefined) { answerString = ''; }
            answerString += `${a};`;
          }
        });
      }
      listAnswers.push({
        id: answer.get('id')?.value,
        form: this.form,
        question: answer.get('question')?.value,
        country: this.country ? this.user.weeeSystem.country : undefined,
        weeeSystem: !this.country ? this.user.weeeSystem : undefined,
        year: this.form.year,
        sharingLevel: answer.get('question')?.value.sharingLevelLocked ? answer.get('question')?.value.sharingLevel : answer.get('sharingLevel')?.value,
        answerString,
        completed: Object.keys(this.formAnswers).length > 0 ? this.formAnswers[0]?.completed : false,
        reasonUnanswered: answer.get('reasonUnanswered')?.value
      });
    });
    if (listAnswers.length === 0) {
      this.messageService.showMessage('No answers to save', 'error');
    } else {
      this.formsService.saveAnswers(listAnswers).subscribe(
        () => {
          const url = this.router.url;
          if (completed) { // marks as completed
            this.formsService.markAsCompleted(
              this.form.id, this.form?.year ? this.form.year : this.yearPreview,
              this.country ? this.user.weeeSystem.country.id : undefined,
              !this.country ? this.user.weeeSystem.id : undefined).subscribe(
              () => {
                this.router.navigateByUrl('/', {skipLocationChange: true}).then(
                  () => this.router.navigate([url])
                );
              }
            );
          } else {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(
              () => this.router.navigate([url])
            );
          }
        }
      );
    }

  }

  private setArrayForm(): void {
    this.availableAnswers.splice(0, this.availableAnswers.length);
    this.questions.forEach((question, index) => {
      const answerFormat = JSON.parse(question.answerFormatString);
      this.answerControl.push(
        this.formBuilder.group({
          id: [null],
          question: [question],
          categoryId: [question.category.id],
          answer: [null, question.mandatory ? Validators.required : ''],
          sharingLevel: [{value: question.sharingLevel, disabled: question.sharingLevelLocked}],
          reasonUnanswered: [],
        })
      );

      switch (question.answerType) {
        case 'NUMBER':
          if (question.mandatory) {
            this.answerControl.at(index).get('answer')?.setValidators(
              [Validators.min(answerFormat.Min), Validators.max(answerFormat.Max), Validators.required]
            );
          } else {
            this.answerControl.at(index).get('answer')?.setValidators([Validators.min(answerFormat.Min), Validators.max(answerFormat.Max)]);
          }
          this.answerControl.at(index).updateValueAndValidity();
          this.availableAnswers.push([]);
          break;
        case 'TEXT':
          if (question.mandatory) {
            this.answerControl.at(index).get('answer')?.setValidators([Validators.maxLength(answerFormat.MaxLength), Validators.required]);
          } else {
            this.answerControl.at(index).get('answer')?.setValidators([Validators.maxLength(answerFormat.MaxLength)]);
          }
          this.answerControl.at(index).updateValueAndValidity();
          this.availableAnswers.push([]);
          break;
        case 'LIST':
          this.availableAnswers.push(answerFormat.AvailableAnswers);
          break;
        case 'BOOLEAN':
          this.availableAnswers.push([]);
          break;
      }
    });

    if (!this.router.url.includes('preview')) {
      this.formsService.getFormAnswers(
        this.form.id, this.form?.year ? this.form.year : this.yearPreview,
        this.country ? this.countryOrSystemId : undefined,
        !this.country ? this.countryOrSystemId : undefined).subscribe(
        data => {
          if (data) {
            this.formAnswers = data;
            data.forEach(answer => {
              this.answerControl.controls.forEach((control, index) => {
                if (answer.question.id === control.get('question')?.value.id) {
                  control.get('id')?.setValue(answer.id);
                  control.get('answer')?.setValue(answer.question.multiSelect ? answer.answerString?.split(';') : (answer.question.answerType == 'NUMBER' ? Number(Number(answer.answerString).toFixed(2)): answer.answerString));
                  control.get('sharingLevel')?.setValue(answer.sharingLevel);
                  control.get('reasonUnanswered')?.setValue(answer.reasonUnanswered);
                  if (answer.reasonUnanswered != null) {
                    this.removeRequired(index, true);
                  }

                  this.unansweredMap.set(
                    answer.question.category.description,
                    (this.unansweredMap.get(answer.question.category.description) as number) - 1
                  );
                }
              });
            });
          }
        }
      );
    }
  }

  private redirectUrl(): void {
    const url: string[] = this.router.url.split('/');
    let navigate = '';
    if (this.router.url.includes('preview')) {
      navigate = '/intelligencereporting/roundofquestions';
    } else {
      for (let i = 0; i < url.length - 2; i++) {
        navigate = navigate.concat(url[i] + '/');
      }
    }
    this.router.navigate([navigate]).then(
      () => {
        // do nothing
      }
    );
  }

}
